import React from 'react';
import { Slot } from '@radix-ui/react-slot';

const NODES = [
  "audio",
  "address",
  "article",
  "aside",
  "canvas",
  "div",
  "footer",
  "header",
  "main",
  "nav",
  "nav",
  "section",
  "span",
  "button",
  "fieldset",
  "input",
  "label",
  "option",
  "select",
  "textarea",
  "figcaption",
  "figure",
  "img",
  "svg",
  "a",
  "dd",
  "details",
  "dl",
  "dt",
  "li",
  "menu",
  "ol",
  "summary",
  "ul",
  "abbr",
  "blockquote",
  "cite",
  "code",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "kbd",
  "p",
  "pre",
  "small",
  "strong",
  "sub",
  "sup",
  "time",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  "video"
];
const Primitive = NODES.reduce((primitive, node) => {
  const Node = React.forwardRef(
    (props, forwardedRef) => {
      const { asChild, ...primitiveProps } = props;
      const Component = asChild != null ? Slot : node;
      return /* @__PURE__ */ React.createElement(Component, {
        ...primitiveProps,
        ref: forwardedRef
      });
    }
  );
  Node.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node };
}, {});

export { Primitive };
//# sourceMappingURL=module.js.map
